<template>
  <div>
    <a class="float-sm-left" href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/baseband.vue" target="_blank" style="color:black">
        <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
    </a>
    <b-button variant="dark" size="sm" @click="unsaveParameters('baseband')">UnSave Results</b-button>
    <b-button variant="success" size="sm" @click="saveParameters('baseband')">Save Results</b-button>
    <b-button variant="danger" size="sm" @click="flagParameters('baseband')">Flag for Pipeline Expert</b-button>
    <b-button class="float-sm-right" variant="warning" size="sm" @click="badParameters('baseband')">Bad Data</b-button>
    <div v-for="(round, index) in basebandItems" :key="index" style="margin-top: 50px;">
      <h4> Last Processed on: {{ round['processedAt'] }}</h4>
      <b-row v-if="round['fitData'] != 0">
        <b-col md="2">
        </b-col>
        <b-col md="8">
          <b-img-lazy fluid v-bind:src="`https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=${round['data']}`"/>
        </b-col>
        <b-col md="2">
        </b-col>
      </b-row>
      <b-row v-else>
        <b-container>
          <p v-if="basebandItems === true" style="color: blue;">
            Baseband data is available for this event but not yet analysed.
          </p>
          <p v-else style="color: red;">
            No baseband data available for this event.
          </p>
        </b-container>
      </b-row>
    </div>
  </div>
</template>

<script>
export default{
  props: [
    'unsaveParameters',
    'saveParameters',
    'flagParameters',
    'badParameters',
    'basebandItems'
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/baseband.vue